import { ErrorPage } from '@innovigo/ui/components/ErrorPage';

export default function NotFoundScreen() {
  return <ErrorPage>This screen doesn't exist.</ErrorPage>;
}
